import { render, staticRenderFns } from "./unitedStates.vue?vue&type=template&id=2b1ffdb0&scoped=true&"
import script from "./unitedStates.vue?vue&type=script&lang=js&"
export * from "./unitedStates.vue?vue&type=script&lang=js&"
import style0 from "./unitedStates.vue?vue&type=style&index=0&id=2b1ffdb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ffdb0",
  null
  
)

export default component.exports